import { useCallback, useEffect } from 'react';
import { compose } from 'ramda';
import { isNilOrEmpty } from 'ramda-extension';
import { useDispatch, useSelector } from 'react-redux';

import { codelistProvider } from 'components/index';
import { codelists } from 'constants/codelists';
import { pushToFilterDataLayer } from 'features/common/gtm/utils';
import { subheaders } from 'features/common/Subheader/constants';
import { useCollapsible } from 'features/common/Subheader/hooks';
import { setVisibleState } from 'features/common/Subheader/slice';
import taskOverview from 'features/views/taskOverview';
import { changeQuickFilterView, fetchTaskTypeList } from 'features/views/taskOverview/actions';
import { formDataFieldsMap } from 'features/views/taskOverview/constants';
import { getQuickFilterState } from 'features/views/taskOverview/selectors';
import history from 'utils/history';
import { cleanse } from 'utils/object';
import { getRoutePath } from 'utils/routeHelper';

import FilterForm from './FilterForm';

const { QUICK_FILTER_STATES } = taskOverview.constants;

export const Filter = () => {
	const dispatch = useDispatch();
	const { visible } = useCollapsible({ id: subheaders.tasksOverview });

	const quickFilterState = useSelector(getQuickFilterState);

	useEffect(() => {
		const searchParams = new URLSearchParams(window.location.search);
		const quickFilter = searchParams.get('quickFilter');

		if (!isNilOrEmpty(quickFilter)) {
			dispatch(changeQuickFilterView(quickFilter));
			history.replace(getRoutePath('tasks'));
		}
	}, [dispatch]);

	const pushQuickFilterToDataLayer = useCallback((type) => {
		const formData = {};
		switch (type) {
			case QUICK_FILTER_STATES.all:
				formData.quickFilterAll = true;
				break;
			case QUICK_FILTER_STATES.tasks:
				formData.quickFilterTasks = true;
				break;
			case QUICK_FILTER_STATES.info:
				formData.quickFilterInfo = true;
				break;
			case QUICK_FILTER_STATES.processed:
				formData.quickFilterProcessed = true;
				break;
			default:
				formData.quickFilterAll = true;
				break;
		}

		pushToFilterDataLayer({
			filterSection: 'Úkoly a informace',
			formData: cleanse(formData),
			formDataFieldsMap,
		});
	}, []);

	useEffect(() => {
		if (!visible) {
			dispatch(fetchTaskTypeList(quickFilterState));
			pushQuickFilterToDataLayer(quickFilterState);
		}
		// eslint-disable-next-line
	}, [dispatch, visible, pushQuickFilterToDataLayer]);

	useEffect(
		() => () => {
			// closeSubheader so quickFilter logic will startUp for next selected user as default
			dispatch(setVisibleState({ id: subheaders.tasksOverview, visible: false }));
		},
		[dispatch],
	);

	return <FilterForm />;
};

// prefetching for subcomponent use
export default compose(codelistProvider(codelists.finishTypes), codelistProvider(codelists.productDomains))(Filter);
